var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYellowBlob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 231,
    viewBox: "0 0 240 231",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.283 3.39198C154.855 0.461002 198.338 -7.72042 223.385 20.4144C249.198 49.4103 239.388 92.9957 230.727 130.825C222.074 168.623 211.959 212.157 176.097 226.976C141.343 241.338 106.387 214.021 73.4959 195.799C44.1056 179.516 11.694 163.447 2.92048 131.034C-6.18145 97.4082 6.84997 61.4461 30.1037 35.4921C51.8362 11.236 84.7979 5.9261 117.283 3.39198Z",
    fill: "#fecc18"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowBlob);
export default __webpack_public_path__ + "static/media/yellowBlob.fd616eab88e1e6463104e1ce79102453.svg";
export { ForwardRef as ReactComponent };